<template>
  <section>
    <h1 class="h4">{{ $t('cita.help_headline') }}</h1>
    <dl class="list-desc-grid list-desc-grid-left list-desc-semibold">
      <template v-for="n in 9">
        <dt :key="'q' + n">{{ $t('cita.help_question' + n) }}</dt>
        <dd :key="'a' + n">{{ $t('cita.help_text' + n) }}</dd>
      </template>
    </dl>
  </section>
</template>

<script>
import TitleMixin from '@/mixins/title';

export default {
  name: 'CitaHelp',

  mixins: [TitleMixin],

  created() {
    this.$webtrekk.viewPage('cita.hilfe');
  },
};
</script>

<style scoped lang="scss">
.list-desc-grid-left dd {
  padding-bottom: 24px;
}
</style>
